import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "@src/api/config";
import { RoleEnum } from "@src/custom-types";
import { showModalSuccess } from "@src/redux/modalTypeSuccess";
import { AppDispatch, RootState } from "@src/redux/store";

export const checkStudentsMassiveApSchool = createAsyncThunk<
  any,
  any,
  {
    dispatch: AppDispatch;
    state: RootState;
  }
>("clients/checkStudentsMassiveApSchool", async (params, thunkApi) => {
  const state = thunkApi.getState();
  const products = state.products as { productSelected: { value: any } };
  const businessLines = state.businessLines as {
    businessLineSelected: { id: any };
  };

  const response = await api.post(`api/clients/student/ap_school/mass`, {
    ...params,
    students: (params.students ?? []).map((student: any) => ({
      ...student,
      // Optional: send null when empty. `state` travels as its NAME (string).
      sex: student.sex || null,
      state: student.state || null,
      city: student.city || null,
      tutorEmail: student.tutorEmail || null
    })),
    product: products.productSelected.value,
    business_line: businessLines.businessLineSelected.id
  });

  return response.data;
});

export const saveStudentsMassiveApSchool = createAsyncThunk<
  any,
  any,
  {
    dispatch: AppDispatch;
    state: RootState;
  }
>("clients/saveStudentsMassiveApSchool", async (params, thunkApi) => {
  const { dispatch } = thunkApi;
  const state = thunkApi.getState();
  const products = state.products as { productSelected: { value: any } };
  const businessLines = state.businessLines as {
    businessLineSelected: { id: any };
  };

  const response = await api.post(`api/clients/student/ap_school/mass/save`, {
    ...params,
    students: state.clientsStudents.validatedStudents.map((student) => {
      return {
        ...student,
        taxData: student.taxData.value,
        // Group is optional: it may arrive null from validation.
        group: student.group?.value ?? null,
        // Already-resolved ids + new fields (all nullable).
        state: student.state?.value ?? null,
        sex: student.sex || null,
        city: student.city || null,
        tutorEmail: student.tutorEmail || null
      };
    }),
    product: products.productSelected.value,
    business_line: businessLines.businessLineSelected.id
  });

  let url = `/users/clients/show/${params.clientId}`;

  switch (state.auth.userData?.role) {
    case RoleEnum.SELLER:
      url = `/seller/clients/show/${params.clientId}`;
      break;
    case RoleEnum.CLIENT:
      url = `/settings`;
  }

  dispatch(
    showModalSuccess({
      message: "Estudiantes cargados con éxito.",
      url
    })
  );

  return {
    params,
    data: response.data
  };
});
